// Keeps the product list URL in sync with the applied list state so a refresh re-renders the same view.
window.updateProductListSearchParams = function (params) {
  const defaultValues = {
    search_string: '',
    supplier_id: '',
    product_group_unique_id: '',
    top_product_group: '',
    selected_location_id: '',
    live_edit: '0',
    page: '1',
  };
  const url = new URL(window.location.href);

  Object.keys(defaultValues).forEach(function (key) {
    const value = params[key] === undefined || params[key] === null ? '' : String(params[key]);
    if (value === '' || value === defaultValues[key]) {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
  });

  window.history.replaceState({}, '', url);
};

// Kept apart from the list state above, which drops every key its caller leaves out.
window.updateProductListParameterGroup = function (parameterGroup) {
  const url = new URL(window.location.href);
  if (parameterGroup) {
    url.searchParams.set('parameter_group', parameterGroup);
  } else {
    url.searchParams.delete('parameter_group');
  }
  window.history.replaceState({}, '', url);
};
